import { Link } from "react-router-dom";

export default function ActionButton({ title, icon: Icon, path }) {
  return (
    <Link to={path}>
      <div className="bg-white rounded-lg shadow p-6 flex flex-col items-center justify-center hover:bg-gray-50 cursor-pointer">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mb-2">
          <Icon className="text-blue-500" size={16} />
        </div>
        <span>{title}</span>
      </div>
    </Link>
  )
}

